import React from 'react';

import { ChannelContentList } from 'components';

import { ContentTypeEnum } from 'constants-content';

function ChannelNoticesList({ match }: any) {
  const channelId = match.params.id;

  return (
    <ChannelContentList
      channelId={channelId}
      contentType={ContentTypeEnum.Notice}
    />
  );
}

export default ChannelNoticesList;
